@if (!isEmbedded()) {
	<app-navbar title="Wynagrodzenia Pilotów"></app-navbar>
}

<div class="salary-list-container" [class.embedded]="isEmbedded()">
	@if (!isEmbedded()) {
		<mat-tab-group
			(selectedIndexChange)="onTabChange($event)"
			[selectedIndex]="selectedTabIndex"
			class="salary-tabs"
		>
			@for (tab of paymentTabs; track tab.value) {
				<mat-tab [label]="tab.label"></mat-tab>
			}
		</mat-tab-group>

		<mat-card class="filters-card mb-3">
			<mat-card-content>
				<form [formGroup]="filterForm" class="filters-form">
					<div class="filters-row">
						<mat-form-field appearance="outline" class="filter-field">
							<mat-label>Data od</mat-label>
							<input [matDatepicker]="dateFromPicker" formControlName="dateFrom" matInput />
							<mat-datepicker-toggle [for]="dateFromPicker" matIconSuffix></mat-datepicker-toggle>
							<mat-datepicker #dateFromPicker></mat-datepicker>
						</mat-form-field>

						<mat-form-field appearance="outline" class="filter-field">
							<mat-label>Data do</mat-label>
							<input [matDatepicker]="dateToPicker" formControlName="dateTo" matInput />
							<mat-datepicker-toggle [for]="dateToPicker" matIconSuffix></mat-datepicker-toggle>
							<mat-datepicker #dateToPicker></mat-datepicker>
						</mat-form-field>

						<mat-form-field appearance="outline" class="filter-field">
							<mat-label>Pilot</mat-label>
							<input formControlName="guideSearch" matInput placeholder="Imię lub nazwisko" />
						</mat-form-field>

						<mat-form-field appearance="outline" class="filter-field">
							<mat-label>Wydarzenie</mat-label>
							<input formControlName="eventSearch" matInput placeholder="Nazwa wydarzenia" />
						</mat-form-field>

						<div class="filter-actions">
							<button (click)="onFilter()" color="primary" mat-raised-button type="button">
								<i class="fas fa-search me-1"></i> Szukaj
							</button>
							<button (click)="onClearFilters()" mat-stroked-button type="button">
								<i class="fas fa-times me-1"></i> Wyczyść
							</button>
						</div>
					</div>
				</form>
			</mat-card-content>
		</mat-card>
	}

	@if (isLoading() && salaries().length === 0) {
		<div class="loading-state">
			<mat-spinner diameter="48"></mat-spinner>
			<p class="loading-text">Ładowanie wynagrodzeń...</p>
		</div>
	} @else if (!isLoading() && salaries().length === 0) {
		<div class="empty-state">
			<h3 class="empty-state-title">Brak wynagrodzeń</h3>
			<p class="empty-state-description">Nie znaleziono żadnych wynagrodzeń do wyświetlenia.</p>
		</div>
	} @else {
		<div class="table-wrapper">
			@if (isLoading()) {
				<div class="table-loading-overlay">
					<mat-spinner diameter="32"></mat-spinner>
				</div>
			}
			<mat-table
				#dataTable
				[dataSource]="matData"
				class="mat-elevation-z2 salary-table"
				matSort
				[matSortActive]="sortActive()"
				[matSortDirection]="sortDirection()"
				(matSortChange)="onSortChange($event)"
				multiTemplateDataRows
			>
				<ng-container matColumnDef="expand">
					<mat-header-cell *matHeaderCellDef class="expand-cell"></mat-header-cell>
					<mat-cell *matCellDef="let element" class="expand-cell">
						<button
							mat-icon-button
							(click)="toggleExpand(element); $event.stopPropagation()"
							[attr.aria-label]="isExpanded(element) ? 'Zwiń szczegóły' : 'Rozwiń szczegóły'"
						>
							<i
								class="fas"
								[class.fa-chevron-down]="!isExpanded(element)"
								[class.fa-chevron-up]="isExpanded(element)"
							></i>
						</button>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="guideName">
					<mat-header-cell *matHeaderCellDef mat-sort-header>Pilot</mat-header-cell>
					<mat-cell *matCellDef="let element">
						<a
							class="guide-name table-link"
							[routerLink]="['/touristGuides', element.guideId]"
							target="_blank"
							>{{ element.guideName }}</a
						>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="eventName">
					<mat-header-cell *matHeaderCellDef mat-sort-header>Wydarzenie</mat-header-cell>
					<mat-cell *matCellDef="let element">
						<div class="event-cell">
							<a
								class="event-name table-link"
								[routerLink]="['/tourism-events', element.eventId]"
								[matTooltip]="element.eventName"
								target="_blank"
								>{{ element.eventName || '-' }}</a
							>
							<span class="type-chip" [attr.data-type]="element.type">
								{{ getTypeLabel(element.type) }}
							</span>
						</div>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="vehicle">
					<mat-header-cell *matHeaderCellDef mat-sort-header>Pojazd</mat-header-cell>
					<mat-cell *matCellDef="let element">
						{{ element.vehiclesDisplay }}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="eventDate">
					<mat-header-cell *matHeaderCellDef mat-sort-header>Data wydarzenia</mat-header-cell>
					<mat-cell *matCellDef="let element">
						<div class="date-range">
							<span class="date-from">{{ element.eventDateFrom | date: 'dd.MM.yyyy' }}</span>
							<span class="date-separator">-</span>
							<span class="date-to">{{ element.eventDateTo | date: 'dd.MM.yyyy' }}</span>
						</div>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="salary">
					<mat-header-cell *matHeaderCellDef>Wynagrodzenie</mat-header-cell>
					<mat-cell *matCellDef="let element">
						@if (element.salaryDisplay.hasValue) {
							<div class="salary-cell">
								<div class="salary-amounts">
									@for (item of element.salaryDisplay.amounts; track item.currency) {
										<span class="salary-value">{{ item.amount | price }} {{ item.currency }}</span>
									}
								</div>
								@if (element.paymentDetails?.totalAdditions?.length > 0) {
									<span class="salary-info">
										Dodatek:
										@for (
											item of element.paymentDetails.totalAdditions;
											track item.currency;
											let last = $last
										) {
											{{ item.amount | price }} {{ item.currency }}
											@if (!last) {
												,
											}
										}
									</span>
								}
								@if (element.paymentDetails?.totalDeductions?.length > 0) {
									<span class="salary-info">
										Potrącenie:
										@for (
											item of element.paymentDetails.totalDeductions;
											track item.currency;
											let last = $last
										) {
											{{ item.amount | price }} {{ item.currency }}
											@if (!last) {
												,
											}
										}
									</span>
								}
							</div>
						} @else {
							<span class="salary-placeholder">Do ustalenia</span>
						}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="toPayAmount">
					<mat-header-cell *matHeaderCellDef>Do wypłaty</mat-header-cell>
					<mat-cell *matCellDef="let element">
						@if (element.toPayDisplay?.amounts?.length > 0) {
							<div class="to-pay-cell">
								@for (item of element.toPayDisplay.amounts; track item.currency) {
									<span class="to-pay-value">{{ item.amount | price }} {{ item.currency }}</span>
								}
							</div>
						} @else {
							<span class="salary-placeholder">-</span>
						}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="contractNeeded">
					<mat-header-cell *matHeaderCellDef>Umowa potrzebna</mat-header-cell>
					<mat-cell *matCellDef="let element">
						@if (element.contractNeeded === true) {
							<span class="contract-needed-yes">Tak</span>
						} @else if (element.contractNeeded === false) {
							<span class="contract-needed-no">Nie</span>
						} @else {
							<span class="contract-needed-placeholder">-</span>
						}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="settlementStatus">
					<mat-header-cell *matHeaderCellDef>Status rozliczenia</mat-header-cell>
					<mat-cell *matCellDef="let element">
						@if (element.settlementStatus) {
							<span class="settled-yes">Rozliczone</span>
						} @else if (element.paymentDueDate) {
							<div class="settlement-pending">
								<span class="settled-no">Nie rozliczono</span>
								<span class="due-date">do {{ element.paymentDueDate | date: 'dd.MM.yyyy' }}</span>
							</div>
						} @else {
							<span class="settlement-placeholder">Data rozliczenia do ustalenia</span>
						}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="invoice">
					<mat-header-cell *matHeaderCellDef mat-sort-header>Umowa/FV</mat-header-cell>
					<mat-cell *matCellDef="let element">
						<span [class.invoice-placeholder]="element.invoiceNumber === '-'">{{
							element.invoiceNumber
						}}</span>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="comment">
					<mat-header-cell *matHeaderCellDef>Komentarz</mat-header-cell>
					<mat-cell *matCellDef="let element">
						@if (element.comment !== '-') {
							<span class="comment-value" [matTooltip]="element.comment">
								{{ element.comment }}
							</span>
						} @else {
							<span class="comment-placeholder">-</span>
						}
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="action">
					<mat-header-cell *matHeaderCellDef>Akcja</mat-header-cell>
					<mat-cell *matCellDef="let element">
						<button (click)="openSalaryForm(element)" color="primary" mat-raised-button>
							<i class="fas fa-edit"></i>
						</button>
					</mat-cell>
				</ng-container>

				@if (!isEmbedded()) {
					<ng-container matColumnDef="expandedDetail">
						<mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns().length">
							@if (isExpanded(element)) {
								<div class="expanded-detail">
									@if (element.paymentDetails) {
										<div class="detail-sections">
											<div class="detail-section">
												<h4 class="detail-section-title">
													<i class="fas fa-plus-circle"></i>
													Dodatki
												</h4>
												@if (element.paymentDetails.additionItems?.length > 0) {
													<table class="detail-table">
														<thead>
															<tr>
																<th>Kwota</th>
																<th>Waluta</th>
																<th>Komentarz</th>
															</tr>
														</thead>
														<tbody>
															@for (
																item of element.paymentDetails.additionItems;
																track $index
															) {
																<tr>
																	<td>{{ item.amount | price }}</td>
																	<td>{{ item.currency }}</td>
																	<td>{{ item.comment || '-' }}</td>
																</tr>
															}
														</tbody>
													</table>
												} @else {
													<p class="no-items">Brak dodatków</p>
												}
											</div>

											<div class="detail-section">
												<h4 class="detail-section-title">
													<i class="fas fa-minus-circle"></i>
													Potrącenia
												</h4>
												@if (element.paymentDetails.deductionItems?.length > 0) {
													<table class="detail-table">
														<thead>
															<tr>
																<th>Kwota</th>
																<th>Waluta</th>
																<th>Komentarz</th>
															</tr>
														</thead>
														<tbody>
															@for (
																item of element.paymentDetails.deductionItems;
																track $index
															) {
																<tr>
																	<td>{{ item.amount | price }}</td>
																	<td>{{ item.currency }}</td>
																	<td>{{ item.comment || '-' }}</td>
																</tr>
															}
														</tbody>
													</table>
												} @else {
													<p class="no-items">Brak potrąceń</p>
												}
											</div>

											<div class="detail-section">
												<h4 class="detail-section-title">
													<i class="fas fa-credit-card"></i>
													Płatności
												</h4>
												@if (element.paymentDetails.paymentItems?.length > 0) {
													<table class="detail-table">
														<thead>
															<tr>
																<th>Kwota</th>
																<th>Waluta</th>
																<th>Metoda</th>
																<th>Data</th>
																<th>Status</th>
																<th>Komentarz</th>
															</tr>
														</thead>
														<tbody>
															@for (
																item of element.paymentDetails.paymentItems;
																track $index
															) {
																<tr>
																	<td>{{ item.amount | price }}</td>
																	<td>{{ item.currency }}</td>
																	<td>
																		{{ paymentMethodLabels[item.paymentMethod] }}
																	</td>
																	<td>
																		{{
																			item.paymentDate
																				? (item.paymentDate
																					| date: 'dd.MM.yyyy')
																				: '-'
																		}}
																	</td>
																	<td>
																		@if (item.confirmed) {
																			<span class="status-confirmed">
																				<i class="fas fa-check"></i> Rozliczone
																			</span>
																		} @else {
																			<span class="status-pending">
																				<i class="fas fa-clock"></i> Oczekujące
																			</span>
																		}
																	</td>
																	<td>{{ item.comment || '-' }}</td>
																</tr>
															}
														</tbody>
													</table>
												} @else {
													<p class="no-items">Brak płatności</p>
												}
											</div>
										</div>
									} @else {
										<p class="no-payment-details">Brak szczegółów płatności</p>
									}
								</div>
							}
						</mat-cell>
					</ng-container>
				}

				<mat-header-row *matHeaderRowDef="displayedColumns()"></mat-header-row>
				<mat-row
					*matRowDef="let row; columns: displayedColumns()"
					[class.expanded-row]="!isEmbedded() && isExpanded(row)"
				></mat-row>
				@if (!isEmbedded()) {
					<mat-row
						*matRowDef="let row; columns: ['expandedDetail']"
						class="detail-row"
						[class.expanded]="isExpanded(row)"
					></mat-row>
				}
			</mat-table>
		</div>

		<mat-paginator
			[length]="totalItems()"
			[pageSize]="pageSize()"
			[pageIndex]="currentPage() - 1"
			[pageSizeOptions]="[10, 20, 50, 100]"
			(page)="onPageChange($event)"
			showFirstLastButtons
			aria-label="Wybierz stronę"
		>
		</mat-paginator>
	}
</div>
